/*
 * School Management System API
 * APIs for managing branches, employees, students, receipts, etc.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: tejabhargavpodila@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.54
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The Receipt model module.
 * @module model/Receipt
 * @version 1.0.0
 */
export default class Receipt {
  /**
   * Constructs a new <code>Receipt</code>.
   * @alias module:model/Receipt
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Receipt</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Receipt} obj Optional instance to populate.
   * @return {module:model/Receipt} The populated <code>Receipt</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Receipt();
      if (data.hasOwnProperty('receiptNumber'))
        obj.receiptNumber = ApiClient.convertToType(data['receiptNumber'], 'String');
      if (data.hasOwnProperty('dateOfPayment'))
        obj.dateOfPayment = ApiClient.convertToType(data['dateOfPayment'], 'String');
      if (data.hasOwnProperty('dateISO'))
        obj.dateISO = ApiClient.convertToType(data['dateISO'], 'String');
      if (data.hasOwnProperty('studentName'))
        obj.studentName = ApiClient.convertToType(data['studentName'], 'String');
      if (data.hasOwnProperty('parentName'))
        obj.parentName = ApiClient.convertToType(data['parentName'], 'String');
      if (data.hasOwnProperty('applicationNumber'))
        obj.applicationNumber = ApiClient.convertToType(data['applicationNumber'], 'String');
      if (data.hasOwnProperty('registeredMobileNumber'))
        obj.registeredMobileNumber = ApiClient.convertToType(data['registeredMobileNumber'], 'String');
      if (data.hasOwnProperty('batch'))
        obj.batch = ApiClient.convertToType(data['batch'], 'String');
      if (data.hasOwnProperty('dateOfJoining'))
        obj.dateOfJoining = ApiClient.convertToType(data['dateOfJoining'], 'String');
      if (data.hasOwnProperty('stream'))
        obj.stream = ApiClient.convertToType(data['stream'], 'String');
      if (data.hasOwnProperty('gender'))
        obj.gender = ApiClient.convertToType(data['gender'], 'String');
      if (data.hasOwnProperty('branch'))
        obj.branch = ApiClient.convertToType(data['branch'], 'String');
      if (data.hasOwnProperty('residenceType'))
        obj.residenceType = ApiClient.convertToType(data['residenceType'], 'String');
      if (data.hasOwnProperty('firstYearTuitionFeePayable'))
        obj.firstYearTuitionFeePayable = ApiClient.convertToType(data['firstYearTuitionFeePayable'], 'Number');
      if (data.hasOwnProperty('firstYearTuitionFeePaid'))
        obj.firstYearTuitionFeePaid = ApiClient.convertToType(data['firstYearTuitionFeePaid'], 'Number');
      if (data.hasOwnProperty('firstYearHostelFeePayable'))
        obj.firstYearHostelFeePayable = ApiClient.convertToType(data['firstYearHostelFeePayable'], 'Number');
      if (data.hasOwnProperty('firstYearHostelFeePaid'))
        obj.firstYearHostelFeePaid = ApiClient.convertToType(data['firstYearHostelFeePaid'], 'Number');
      if (data.hasOwnProperty('secondYearTuitionFeePayable'))
        obj.secondYearTuitionFeePayable = ApiClient.convertToType(data['secondYearTuitionFeePayable'], 'Number');
      if (data.hasOwnProperty('secondYearTuitionFeePaid'))
        obj.secondYearTuitionFeePaid = ApiClient.convertToType(data['secondYearTuitionFeePaid'], 'Number');
      if (data.hasOwnProperty('secondYearHostelFeePayable'))
        obj.secondYearHostelFeePayable = ApiClient.convertToType(data['secondYearHostelFeePayable'], 'Number');
      if (data.hasOwnProperty('secondYearHostelFeePaid'))
        obj.secondYearHostelFeePaid = ApiClient.convertToType(data['secondYearHostelFeePaid'], 'Number');
      if (data.hasOwnProperty('firstYearTotalTuitionFeePaid'))
        obj.firstYearTotalTuitionFeePaid = ApiClient.convertToType(data['firstYearTotalTuitionFeePaid'], 'Number');
      if (data.hasOwnProperty('firstYearTotalTuitionFeePending'))
        obj.firstYearTotalTuitionFeePending = ApiClient.convertToType(data['firstYearTotalTuitionFeePending'], 'Number');
      if (data.hasOwnProperty('firstYearTotalHostelFeePaid'))
        obj.firstYearTotalHostelFeePaid = ApiClient.convertToType(data['firstYearTotalHostelFeePaid'], 'Number');
      if (data.hasOwnProperty('firstYearTotalHostelFeePending'))
        obj.firstYearTotalHostelFeePending = ApiClient.convertToType(data['firstYearTotalHostelFeePending'], 'Number');
      if (data.hasOwnProperty('secondYearTotalTuitionFeePaid'))
        obj.secondYearTotalTuitionFeePaid = ApiClient.convertToType(data['secondYearTotalTuitionFeePaid'], 'Number');
      if (data.hasOwnProperty('secondYearTotalTuitionFeePending'))
        obj.secondYearTotalTuitionFeePending = ApiClient.convertToType(data['secondYearTotalTuitionFeePending'], 'Number');
      if (data.hasOwnProperty('secondYearTotalHostelFeePaid'))
        obj.secondYearTotalHostelFeePaid = ApiClient.convertToType(data['secondYearTotalHostelFeePaid'], 'Number');
      if (data.hasOwnProperty('secondYearTotalHostelFeePending'))
        obj.secondYearTotalHostelFeePending = ApiClient.convertToType(data['secondYearTotalHostelFeePending'], 'Number');
      if (data.hasOwnProperty('modeOfPayment'))
        obj.modeOfPayment = ApiClient.convertToType(data['modeOfPayment'], 'String');
      if (data.hasOwnProperty('chequeNumber'))
        obj.chequeNumber = ApiClient.convertToType(data['chequeNumber'], 'String');
      if (data.hasOwnProperty('studentStatus'))
        obj.studentStatus = ApiClient.convertToType(data['studentStatus'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} receiptNumber
 */
Receipt.prototype.receiptNumber = undefined;

/**
 * @member {String} dateOfPayment
 */
Receipt.prototype.dateOfPayment = undefined;

/**
 * @member {String} dateISO
 */
Receipt.prototype.dateISO = undefined;

/**
 * @member {String} studentName
 */
Receipt.prototype.studentName = undefined;

/**
 * @member {String} parentName
 */
Receipt.prototype.parentName = undefined;

/**
 * @member {String} applicationNumber
 */
Receipt.prototype.applicationNumber = undefined;

/**
 * @member {String} registeredMobileNumber
 */
Receipt.prototype.registeredMobileNumber = undefined;

/**
 * @member {String} batch
 */
Receipt.prototype.batch = undefined;

/**
 * @member {String} dateOfJoining
 */
Receipt.prototype.dateOfJoining = undefined;

/**
 * @member {String} stream
 */
Receipt.prototype.stream = undefined;

/**
 * Allowed values for the <code>gender</code> property.
 * @enum {String}
 * @readonly
 */
Receipt.GenderEnum = {
  /**
   * value: "Male"
   * @const
   */
  male: "Male",

  /**
   * value: "Female"
   * @const
   */
  female: "Female"
};
/**
 * @member {module:model/Receipt.GenderEnum} gender
 */
Receipt.prototype.gender = undefined;

/**
 * @member {String} branch
 */
Receipt.prototype.branch = undefined;

/**
 * @member {String} residenceType
 */
Receipt.prototype.residenceType = undefined;

/**
 * @member {Number} firstYearTuitionFeePayable
 */
Receipt.prototype.firstYearTuitionFeePayable = undefined;

/**
 * @member {Number} firstYearTuitionFeePaid
 */
Receipt.prototype.firstYearTuitionFeePaid = undefined;

/**
 * @member {Number} firstYearHostelFeePayable
 */
Receipt.prototype.firstYearHostelFeePayable = undefined;

/**
 * @member {Number} firstYearHostelFeePaid
 */
Receipt.prototype.firstYearHostelFeePaid = undefined;

/**
 * @member {Number} secondYearTuitionFeePayable
 */
Receipt.prototype.secondYearTuitionFeePayable = undefined;

/**
 * @member {Number} secondYearTuitionFeePaid
 */
Receipt.prototype.secondYearTuitionFeePaid = undefined;

/**
 * @member {Number} secondYearHostelFeePayable
 */
Receipt.prototype.secondYearHostelFeePayable = undefined;

/**
 * @member {Number} secondYearHostelFeePaid
 */
Receipt.prototype.secondYearHostelFeePaid = undefined;

/**
 * @member {Number} firstYearTotalTuitionFeePaid
 */
Receipt.prototype.firstYearTotalTuitionFeePaid = undefined;

/**
 * @member {Number} firstYearTotalTuitionFeePending
 */
Receipt.prototype.firstYearTotalTuitionFeePending = undefined;

/**
 * @member {Number} firstYearTotalHostelFeePaid
 */
Receipt.prototype.firstYearTotalHostelFeePaid = undefined;

/**
 * @member {Number} firstYearTotalHostelFeePending
 */
Receipt.prototype.firstYearTotalHostelFeePending = undefined;

/**
 * @member {Number} secondYearTotalTuitionFeePaid
 */
Receipt.prototype.secondYearTotalTuitionFeePaid = undefined;

/**
 * @member {Number} secondYearTotalTuitionFeePending
 */
Receipt.prototype.secondYearTotalTuitionFeePending = undefined;

/**
 * @member {Number} secondYearTotalHostelFeePaid
 */
Receipt.prototype.secondYearTotalHostelFeePaid = undefined;

/**
 * @member {Number} secondYearTotalHostelFeePending
 */
Receipt.prototype.secondYearTotalHostelFeePending = undefined;

/**
 * @member {String} modeOfPayment
 */
Receipt.prototype.modeOfPayment = undefined;

/**
 * @member {String} chequeNumber
 */
Receipt.prototype.chequeNumber = undefined;

/**
 * Allowed values for the <code>studentStatus</code> property.
 * @enum {String}
 * @readonly
 */
Receipt.StudentStatusEnum = {
  /**
   * value: "Active"
   * @const
   */
  active: "Active",

  /**
   * value: "Cancelled"
   * @const
   */
  cancelled: "Cancelled"
};
/**
 * @member {module:model/Receipt.StudentStatusEnum} studentStatus
 */
Receipt.prototype.studentStatus = undefined;

